export interface Meta {
  label: string;
  icon: string;
  className: string;
}

export function reportStatusMeta(status: string | undefined | null): Meta {
  const s = (status ?? '').toLowerCase();
  if (s === 'resolved' || s === 'resolve' || s === 'traite' || s === 'résolu') {
    return { label: 'Résolu', icon: 'ri-check-double-line', className: 'bg-secondary-100 text-secondary-900' };
  }
  if (s === 'dismissed' || s === 'dismiss' || s === 'ignore' || s === 'ignoré') {
    return { label: 'Ignoré', icon: 'ri-close-line', className: 'bg-background-100 text-foreground-500' };
  }
  return { label: 'Ouvert', icon: 'ri-flag-2-line', className: 'bg-accent-100 text-accent-900' };
}

export function entityTypeMeta(entityType: string | undefined | null): Meta {
  const t = (entityType ?? '').toLowerCase();
  if (t.includes('coin')) {
    return { label: 'Le Coin', icon: 'ri-chat-smile-3-line', className: 'text-foreground-600' };
  }
  if (t.includes('comment')) {
    return { label: 'Commentaire', icon: 'ri-message-3-line', className: 'text-foreground-600' };
  }
  if (t.includes('user')) {
    return { label: 'Utilisateur', icon: 'ri-user-3-line', className: 'text-foreground-600' };
  }
  return { label: 'Activité', icon: 'ri-compass-3-line', className: 'text-foreground-600' };
}

export function userRoleMeta(roles: string[] | undefined | null): { label: string; isAdmin: boolean; isModerator: boolean } {
  const list = (roles ?? []).map((r) => r.toLowerCase());
  const isAdmin = list.some((r) => r === 'admin' || r === 'administrator' || r === 'administrateur');
  const isModerator = list.some((r) => r === 'moderator' || r === 'modérateur' || r === 'modo');
  if (isAdmin) return { label: 'Administrateur', isAdmin: true, isModerator: false };
  if (isModerator) return { label: 'Modérateur', isAdmin: false, isModerator: true };
  return { label: 'Membre', isAdmin: false, isModerator: false };
}

export const ROLE_OPTIONS = [
  { value: 'Member', label: 'Membre' },
  { value: 'Moderator', label: 'Modérateur' },
  { value: 'Admin', label: 'Administrateur' },
];